const EVENT_NAME_VIEW_SEARCH_RESULTS = 'view_search_results';

window.onGtmReady(function() {
  try {
    if (typeof window.dataLayer === 'undefined') {
      console.error(`${EVENT_NAME_VIEW_SEARCH_RESULTS} - dataLayer not available.`);
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const searchTerm = urlParams.get('q') || '';
    
    if (!searchTerm) return;

    let retryCount = 0;
    const maxRetries = 50;

    const checkElement = () => {
      const resultsElement = document.getElementById('results-number');

      if (resultsElement && resultsElement.hasAttribute('data-total-product')) {
        const resultsCount = parseInt(resultsElement.getAttribute('data-total-product'), 10) || 0;
        
        window.dataLayer.push({
          event: EVENT_NAME_VIEW_SEARCH_RESULTS,
          search: {
            term: searchTerm,
            results: resultsCount
          },
          _clear: true
        });

        console.info(`✓ GTM event ${EVENT_NAME_VIEW_SEARCH_RESULTS} pushed to dataLayer.`);
      } else if (++retryCount < maxRetries) {
        setTimeout(checkElement, 100);
      }
    }

    checkElement();
  } catch (error) {
    console.error(`Error tracking ${EVENT_NAME_VIEW_SEARCH_RESULTS}:`, error);
  }
});
